module.exports = __webpack_public_path__ + "img/menu_1.ae9d371b.svg";